import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <img 
                src="https://static.readdy.ai/image/e7430320e3bc3f9244a461515e2266b3/ff55c5fd36070f5cd8d5f73f7b8b3fc3.jpeg"
                alt="錏設工程行"
                className="h-10 w-auto object-contain"
              />
              <h3 className="text-2xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
                錏設工程行
              </h3>
            </div>
            <p className="text-gray-300 mb-4 leading-relaxed">
              專業噴砂噴漆工程服務，30年實務經驗，品質第一、客戶滿意。
              提供工業及公共工程的完整解決方案。
            </p>
            <div className="space-y-2">
              <div className="flex items-center">
                <i className="ri-phone-line mr-3 text-teal-400"></i>
                <span>0989-246-807</span>
              </div>
              <div className="flex items-center mb-4">
                <i className="ri-mail-line mr-3 text-teal-400"></i>
                <a href="mailto:info@yashe-construction.com" className="hover:text-teal-400 transition-colors cursor-pointer">
                  info@yashe-construction.com
                </a>
              </div>
              <div className="flex items-center">
                <i className="ri-map-pin-line mr-3 text-teal-400"></i>
                <span>高雄市三民區明誠一路25號</span>
              </div>
            </div>
          </div>

          <div className="flex flex-col space-y-3">
            <a href="tel:+886989246807" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
              <i className="ri-phone-line mr-2"></i>
              0989-246-807
            </a>
            <a 
              href="mailto:info@yashe-construction.com"
              className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer"
            >
              <i className="ri-mail-line mr-2"></i>
              info@yashe-construction.com
            </a>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">服務項目</h4>
            <ul className="space-y-2">
              <li className="text-gray-300">噴砂噴漆服務</li>
              <li className="text-gray-300">金屬表面除鏽</li>
              <li className="text-gray-300">防鏽處理</li>
              <li className="text-gray-300">工程承攬</li>
              <li className="text-gray-300">工程器具轉運運輸</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 錏設工程行. 版權所有.
          </p>
          <div className="mt-4 md:mt-0">
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
